import { fetchApiGateway } from "@nova/fetch-api-gateway"
import useSWR from "swr"

export const useProjectLayerGeometry = ({
    orgId,
    projectId,
    enabled = true,
}: {
    orgId: string | undefined
    projectId: string | undefined
    enabled?: boolean
}) => {
    const swr = useSWR(
        enabled && orgId && projectId ? ["project-layer-geometry", orgId, projectId] : null,
        () =>
            fetchApiGateway("get /org/:orgId/project/:projectId/layer-geometry", {
                params: { orgId: orgId!, projectId: projectId! },
            }),
        { revalidateOnFocus: false, revalidateOnMount: true }
    )
    return {
        boxes: swr.data?.boxes ?? [],
        points: swr.data?.points ?? [],
        overall: swr.data?.overall,
        loading: swr.isLoading,
        error: swr.error as Error | undefined,
    }
}
